export function compareBy<T>(key: keyof T): (a: T, b: T) => boolean {
  return (a, b) => a[key] === b[key]
}
